/** Colour-coded badge for appointment display status, driven by APPOINTMENT_STATUS_STYLES. */

import { Badge } from '@/frontend/components/ui/badge'
import { getStatusStyle } from '@/frontend/features/appointments/appointments.utils'

export function AppointmentStatusBadge({
  status,
  size,
}: {
  status: string
  size?: React.ComponentPropsWithoutRef<typeof Badge>['size']
}) {
  const style = getStatusStyle(status)
  const Icon = style.icon

  return (
    <Badge variant={style.color} size={size}>
      <Icon data-icon="inline-start" />
      {style.label}
    </Badge>
  )
}
